interface Props {
  /** 기본값: '데이터를 불러오는 중 오류가 발생했습니다.' */
  message?: string;
}

/**
 * API 요청 실패 시 페이지 상단에 표시하는 에러 배너.
 * useQuery의 error 상태와 함께 사용한다.
 */
export default function ErrorAlert({ message = '데이터를 불러오는 중 오류가 발생했습니다.' }: Props) {
  return (
    <div className="bg-text-red/10 border border-text-red/30 text-text-red px-6 py-4 rounded-lg flex items-center space-x-3">
      <i className="fas fa-exclamation-circle text-2xl"></i>
      <span>{message}</span>
    </div>
  );
}
